module.exports = __webpack_public_path__ + "static/image_6-746b2d8de329a4d311277e3d95f6a076.jpg";